import React from "react";
import PropTypes from "prop-types";
import "./App.css";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Login from "./Login/Login";
import Routes from "./Routes";
import { connect } from "react-redux";
import PrivateRoute from "./PrivateRoute";
import {
  logout,
  isLoggedIn,
  fetchUser,
  updateSnackbar,
  closeSnackbar
} from "../actions";
import Grid from "@material-ui/core/Grid";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

class App extends React.Component {
  componentDidMount() {
    console.log("[APP] COMPONENTDIDMOUNT: isLoggedIn dispatched");
    this.props.isLoggedIn();
  }

  componentDidUpdate(prevProps) {
    console.log(
      "[APP] COMPONENTDIDUPDATE:",
      prevProps.auth.uid,
      this.props.auth.uid,
      this.props.user.uid
    );
    if (
      this.props.auth.uid !== prevProps.auth.uid &&
      this.props.auth.uid !== this.props.user.uid
    ) {
      if (this.props.auth.uid !== "init" && this.props.auth.uid !== "0") {
        console.log(
          "[APP] COMPONENTDIDUPDATE: fetchUser dispatched for",
          this.props.auth.uid
        );
        this.props.fetchUser(this.props.auth.uid);
      }
    }
  }

  render() {
    console.log("[APP] RENDER", this.props.user.uid);
    return (
      <Grid container style={{ maxWidth: "100vw", overflow: "hidden" }}>
        <BrowserRouter>
          <Switch>
            <Route path="/login" component={Login} auth={this.props.auth} />
            <PrivateRoute
              path="/"
              component={Routes}
              auth={this.props.auth}
              user={this.props.user}
            />
          </Switch>
        </BrowserRouter>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left"
          }}
          open={this.props.snackbar.open}
          autoHideDuration={6000}
          onClose={() => {
            this.props.closeSnackbar();
          }}
          ContentProps={{
            "aria-describedby": "message-id"
          }}
          message={this.props.snackbar.message}
          action={[
            <IconButton
              key="close"
              aria-label="close"
              color="inherit"
              className=""
              onClick={() => {
                this.props.closeSnackbar();
              }}
            >
              <CloseIcon />
            </IconButton>
          ]}
        />
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    user: state.user,
    snackbar: state.snackbar
  };
}

App.propTypes = {
  auth: PropTypes.object,
  user: PropTypes.object,
  snackbar: PropTypes.object,
  logout: PropTypes.func,
  isLoggedIn: PropTypes.func,
  fetchUser: PropTypes.func,
  updateSnackbar: PropTypes.func,
  closeSnackbar: PropTypes.func
};

export default connect(mapStateToProps, {
  logout,
  isLoggedIn,
  fetchUser,
  updateSnackbar,
  closeSnackbar
})(App);
